import { render, staticRenderFns } from "./IfeaInfo.vue?vue&type=template&id=b863b210"
import script from "./IfeaInfo.vue?vue&type=script&lang=js"
export * from "./IfeaInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports